module.exports = __webpack_public_path__ + "static/media/journal.a480e988.png";